module.exports = __webpack_public_path__ + "static/media/startup.e42b4556.svg";